import { get } from 'lodash-es'

const keyToMutation = {
  'amptheme': 'UPDATE_AMPTHEME',
  'settings': 'UPDATE_SETTINGS'
}

export default (stateKey, computedKeys, useCategory = false) => {
  const computed = {}

  computedKeys.forEach(key => {
    const newKey = key.replace('.', '__')

    computed[newKey] = {
      get () {
        const k = useCategory
          ? `${stateKey}.${this.category}.${key}`
          : `${stateKey}.${key}`

        return get(this.$store.state, k)
      },
      set (value) {
        const k = useCategory ? this.category : key
        const v = useCategory ? { [key]: value } : value
        const update = { key: k, value: v }

        this.$store.commit(keyToMutation[stateKey], update)
      }
    }
  })

  return { computed }
}
